'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname, useSearchParams } from 'next/navigation';
import { useModalProvider } from '@dr-pam/common-components/Components/Modal/ModalProvider';
import LoginForm from './LoginForm';

const MODAL_ID = 'login';

export default function LoginModal() {
	const modalProvider = useModalProvider();
	const pathname = usePathname();
	const searchParams = useSearchParams();

	const currentSearchParams = searchParams.toString();
	const fullUrl = pathname + (currentSearchParams ? `?${currentSearchParams}` : '');

	const onClose = () => modalProvider.closeModal(MODAL_ID);

	return (
		<div className="login-modal">
			<h2 className="login-modal__title">Login</h2>
			<LoginForm onClose={onClose} redirectUrl={fullUrl}>
				<Link className="forgot-password" href="/forgot-password" onClick={onClose}>
					Forgot password
				</Link>
			</LoginForm>
		</div>
	);
}

export function showLoginModal(modalProvider: ReturnType<typeof useModalProvider>) {
	modalProvider.openModal({
		modalId: MODAL_ID,
		className: 'popup-overlay blur',
		showClose: true,
		children: <LoginModal />,
	});
}
